import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";

import { ConfluenceTemplateMessages } from "@/components/confluence/templates/template-messages";
import { getTemplateByLine } from "@/components/confluence/templates/util/template-util";
import { Template } from "@/content/templates/template.types";

interface TemplateAuthorProps {
    template: Template;
}

const templateAuthor = css({
    fontSize: "0.75rem",
    lineHeight: "1.3125rem",
    fontWeight: 500,
    color: "#0052CC",
    fontFamily: "var(--bxp-charlie-display-font-family)",
    margin: 0,
    marginBlockEnd: "24px",
    textTransform: "uppercase"
});

export const TemplateAuthor = ({ template }: TemplateAuthorProps) => {
    const contributorName = getTemplateByLine(template);

    return (
        contributorName && (
            <h3 css={templateAuthor}>
                <FormattedMessage
                    {...ConfluenceTemplateMessages.templateAuthorByLine}
                    values={{
                        author: contributorName
                    }}
                />
            </h3>
        )
    );
};
